module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/48X2x0/tc-custom/1.png?1685203880013?1725649954835",
      "alt": "This image is the cover for the book Kerry the Unicorn and Her Adventures in Space"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Kerry the Unicorn and Her Adventures in Space\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("In the deep vastness of space, there lived a unicorn with a long sad face. She had lovely pink wings and a long wavy mane, but there was no escaping her unbearable pain. Kerry flew far and wide looking for a friend, someone she could play with until the end.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      John Longman, Sophie Jacobs\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Born in Rochford, Essex, John Longman is an English author dedicated to the written word. With a vivid imagination and a penchant for dabbling in various genres of story-telling, there’s a story for everyone and there’s no way of predicting what he will write next. When not lurking in a darkened room, perched on the edge of his seat, and staring intently at a computer screen, he enjoys working with his hands, soaking up the sunshine and loves to spend as much time on the water as he does in it. Scuba diving – it’s not just a hobby but a way of life.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 71
// module chunks = 0